import {
  Home,
  Users,
  Building,
  FileText,
  Calendar,
  Mail,
  Phone,
  DollarSign,
  BarChart3,
  Settings,
  Shield,
  Clock,
  Archive,
  MessageSquare,
  Bell,
  User,
  Briefcase,
  CreditCard,
  Truck,
  Package,
  Target,
  TrendingUp,
  FileBarChart,
  Database,
  Globe,
  HelpCircle,
  BookOpen,
  Wrench,
  Palette,
} from 'lucide-react';

export const XOFFI_MENU_SIDEBAR = [
  {
    title: 'Erneut anmelden',
    icon: User,
    path: '/signin',
    onClick: () => {
      if (typeof window !== 'undefined') {
        const currentUrl = window.location.href;
        localStorage.clear();
        window.location.href = `/signin?return=${encodeURIComponent(currentUrl)}`;
      }
    }
  },

  {
    heading: '⚠️ Menü konnte nicht geladen werden',
    description: 'Bitte melden Sie sich erneut an oder kontaktieren Sie den Support.'
  }
];

export const XOFFI_MENU_COMPACT = [
  {
    title: 'Erneut anmelden',
    icon: User,
    path: '/signin',
    onClick: () => {
      if (typeof window !== 'undefined') {
        const currentUrl = window.location.href;
        localStorage.clear();
        window.location.href = `/signin?return=${encodeURIComponent(currentUrl)}`;
      }
    }
  }
];